export default __webpack_public_path__ + "static/media/job_2.616510e0.png";